export default __webpack_public_path__ + "static/media/pic-what-we-do.15677eca.jpg";